<template>
    <a-modal title="更换企业信息"
             :width="750"
             :visible="visible"
             @cancel="$emit('cancel')"
             @ok="onSubmit"
             :maskClosable="false"
             :destroyOnClose="true"
             :confirmLoading="modalLoading">
        <a-form :form="form">
            <table style="width:80%;height: 380px;" >
                <tr>
                    <th>单位名称：</th>
                    <td>
                        <a-form-item>
                        <a-input
                                v-decorator="['supplierName',{initialValue:supplier.supplierName,rules:[
                                    {required: true,message:'单位名称不能为空'},
                                ]}]"
                        />
                        </a-form-item>
                    </td>
                </tr>

                <tr>
                    <th>社会统一信用代码：</th>
                    <td>
                        <a-form-item>
                        <a-input
                                v-decorator="['supplierCode',{initialValue:supplier.supplierCode,rules: [
                                    {required: true,message:'社会统一信用代码'},
                                    {validator: checkSupplierCode}
                                ]}]"
                        />
                        </a-form-item>
                    </td>
                </tr>

                <tr>
                    <th>省市县：</th>
                    <td>
                        <area-select type='all' size="small" :level='2' :data="pcaa" @change="change"
                                     v-model="selected"></area-select>
                    </td>
                </tr>

                <tr>
                    <th>注册地址</th>
                    <td>
                        <a-form-item  >
                            <br>
                            <a-input
                                    :addon-before="complete"
                                    v-decorator="['supplierAddress',{initialValue:supplier.supplierAddress ,rules: [{ required: true, message: '注册地址不能为空'}]}]"
                            />
                        </a-form-item>
                    </td>
                </tr>

            </table>
        </a-form>
    </a-modal>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'
    import qs from 'qs'
    import 'vue-area-linkage/dist/index.css'
    import {pca, pcaa} from 'area-data'
    import UploadSelector from '@/components/selector/UploadSelector'

    export default {
        created() {
            this.userName = this.$store.getters.nickname
        },
        props: {
            visible: {
                type: Boolean,
                default: false
            }
        },
        components: {
            UploadSelector,
        },
        data() {
            return {
                labelCol: { lg: { span: 6 }, sm: { span: 6 } },
                wrapperCol: { lg: { span: 18 }, sm: { span: 18 } },
                form: this.$form.createForm(this),
                id: this.$route.query.id,
                pca: pca,
                pcaa: pcaa,
                modalLoading: false,
                params: {},
                loading: false,
                supplier: '',
                city: '',
                province: '',
                district: '',
                // selected:[pcaa[86]['110000'],pcaa['110000']['110100'],pcaa['110100']['110101']]
                selected: [],
                value:'1',
                complete: '',
                cityName: '',
                provinceName: '',
                districtName: '',
                natureType: '',
                supplierType: ''
            }
        },
        methods: {
            initInfo(id) {
                let that = this
                this.$http.get('/api/v1/supplier/account/get_supplier_info.json?id=' + id).then(function (res) {
                    console.log(that.supplier)
                    that.supplier = res.result.supplier
                    if (that.supplier.province) {
                        that.selected.push(that.pcaa[86][that.supplier.province])
                    }
                    if (that.supplier.province && that.supplier.city) {
                        that.selected.push(that.pcaa[that.supplier.province][that.supplier.city])
                    }
                    if (that.supplier.province && that.supplier.city && that.supplier.district) {
                        // pcaa['110100']['110101']
                        that.selected.push(that.pcaa[that.supplier.city][that.supplier.district])
                    }
                    that.natureType = that.supplier.natureType
                    that.supplierType = that.supplier.supplierType
                })
            },
            onSubmit() {
                let params = {...this.form.getFieldsValue()}
                if (this.selected.length !== 3) {
                    this.$message.error('请选择省市县不能为空!')
                    return
                }
                for (var p in this.selected[0]) {
                    this.province = p
                    this.provinceName = this.selected[0][p]
                }
                for (var p in this.selected[1]) {
                    this.city = p
                    this.cityName = this.selected[1][p]
                }
                for (var p in this.selected[2]) {
                    this.district = p
                    this.districtName = this.selected[2][p]
                }
                // params.supplierAddress = params.registerAddress
                if (this.cityName === '市辖区' ) {
                    params.completeRegisterAddress = this.provinceName  + this.districtName + params.supplierAddress
                }else {
                    params.completeRegisterAddress = this.provinceName + this.cityName + this.districtName + params.supplierAddress
                }
                let that = this
                this.form.validateFields((err, values) => {
                    if (err) {
                        return
                    }
                    params.province = this.province
                    params.city = this.city
                    params.district = this.district
                    console.log(params)
                    // this.$http.post('api/v1/supplier/account/change_enterprise.json',qs.stringify(params, {allowDots: true})).then(function (result) {
                    //     if (result.code === 200) {
                    //         that.$router.push('/enterprise/EnterpriseAuth')
                    //     }
                    // })
                })
            },
            checkSupplierCode(rule, value, callback) {
                var reg = /[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}/g
                value = value.replace(/\s*/g,"");
                if (!reg.test(value)) {
                    callback('社会统一信用代码格式不正确')
                }
                callback()
            },
            change(e) {
                this.complete = ''
                var area = ''
                for (let i = 0; i < e.length; i++) {
                    var it = e[i]
                    console.log(it)
                    for (var p in it) {
                        area =  area + it[p]
                    }
                }
                if (area.indexOf("市辖区") != -1) {
                    area = area.replace("市辖区","")
                }
                this.complete = area
            },
        }
    };
</script>
<style lang="less" scoped>
    .ant-input {
        width: 300px;
    }

    .fx-form th {
        width: 130px;
    }
    /*table {*/
    /*    height: 400px;*/
    /*}*/

</style>
